import { jsx, jsxs } from "react/jsx-runtime";
import { Classes, Icon } from "@blueprintjs/core";
import React from "react";
export const dragNoticeEl = /* @__PURE__ */ jsxs(
  "div",
  {
    className: Classes.TEXT_MUTED,
    style: {
      padding: 10,
      fontSize: "12px"
    },
    children: [
      /* @__PURE__ */ jsx(Icon, { icon: "info-sign", size: 12 }),
      " Drag columns to reorder them"
    ]
  }
);
